import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-sso-entry",
  template: "",
})
export class SsoEntryComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit(): void {
    const code = this.route.snapshot.queryParams["code"];

    if (typeof code === "string" && code.trim().length > 0) {
      void this.router.navigate(["/auth/callback/sso"], {
        queryParams: { code },
        replaceUrl: true,
      });
      return;
    }

    void this.router.navigate(["/auth/login"], { replaceUrl: true });
  }
}
